/* eslint-disable react/prop-types */
import { AuthContext } from 'context/AuthContext';
import React, { useContext } from 'react';

const HRNominationForm = ({ data }) => {
  const { user } = useContext(AuthContext);
  console.log('🚀 ~ HRNominationForm ~ user:', user);

  if (!data) {
    return null;
  }
  const { personal_information } = data;
  return (
    <React.Fragment>
      <style>
        {`
    body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 10px;
        font-size: 12px;
        line-height: 1.4;
      }
      .container {
        max-width: 800px;
        margin: 0 auto;
        padding: 15px;
      }
      .header {
        text-align: center;
        margin-bottom: 20px;
      }
      .form-number {
        text-align: center;
        font-weight: bold;
        margin-bottom: 10px;
        font-size: 13px;
      }
      .form-title {
        text-align: center;
        margin-bottom: 5px;
      }
      .main-title {
        font-weight: bold;
        font-size: 16px;
        text-decoration: underline;
        margin-bottom: 5px;
      }
      .subtitle {
        font-size: 12px;
        margin-bottom: 20px;
      }
      .field-row {
        display: flex;
        margin-bottom: 8px;
        align-items: baseline;
      }
      .field-label {
        min-width: 200px;
        font-weight: normal;
      }
      .field-value {
        flex: 1;
        border-bottom: 1px solid #000;
        padding-bottom: 2px;
        margin-left: 10px;
        text-align: center;
        font-weight: bold;
      }
      .address-section {
        margin: 15px 0;
      }
      .address-label {
        /* font-weight: bold; */
        margin-bottom: 5px;
        text-decoration: underline;
      }
      .address-value {
        border-bottom: 1px solid #000;
        padding: 5px 0;
        margin-bottom: 8px;
      }
      .address-value.dotted {
        /* border-bottom: 1px solid #000; */
        border-bottom-style: dotted;
        /* padding: 5px 0; */
        /* margin-bottom: 8px; */
      }
      .dotted-line {
        border-bottom: 2px dotted #000;
        margin: 10px 0;
      }
      .nomination-text {
        margin: 20px 0;
        text-align: justify;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0;
      }
      th,
      td {
        border: 1px solid #000;
        padding: 8px;
        text-align: center;
        vertical-align: middle;
      }
      th {
        background-color: #f0f0f0;
        font-weight: bold;
        font-size: 11px;
      }
      .certification {
        margin: 20px 0;
      }
      .certification ol {
        margin: 10px 0;
        padding-left: 25px;
      }
      .certification li {
        margin-bottom: 0px;
      }
      .signature-section {
        margin: 30px 0;
        text-align: end;
      }
      .certificate-title {
        font-weight: bold;
        text-align: center;
        margin: 25px 0 15px;
        font-size: 14px;
      }
      .certificate-text {
        margin: 15px 0;
        text-align: justify;
      }
      .signature-line {
        display: flex;
        justify-content: space-between;
        margin: 30px 0;
      }
      .signature-box {
        text-align: center;
        width: 300px;
      }
      .company-info {
        text-align: center;
        margin: 20px 0;
        margin-top: 20px;
        font-weight: bold;
      }
      .dotted-underline {
        border-bottom: 1px dotted #000;
        display: inline-block;
        min-width: 300px;
        text-align: center;
      }
      .print-button {
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 10px 20px;
        background-color: #4caf50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 16px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        z-index: 1000;
      }
      .print-button:hover {
        background-color: #45a049;
      }

      /* Print specific styles */
      @media print {
        body {
          margin: 0;
          padding: 0;
          background-color: white;
          font-size: 11px;
        }
        .container {
          max-width: 100%;
          border: none;
          padding: 10px;
          margin: 0;
        }
        .print-button {
          display: none;
        }
        table {
          page-break-inside: avoid;
        }
        @page {
          size: A4;
          margin: 0.5cm;
        }
      }
            `}
      </style>
      <div className="container">
        {/* <div class="form-number">KVL_HR_NOMINATIONDECLARATIONFORM_KVL2025001</div> */}
        <div className="header">
          <div className="form-title">Form - 1</div>
          <div className="main-title">NOMINATION AND DECLARATION FORM</div>
          <div className="subtitle">(See Rule - 3)</div>
        </div>
        <div className="field-row">
          <span className="field-label">
            1. Name of person making nomination
          </span>
          <span className="field-value">
            {personal_information.first_name} {personal_information.last_name}{' '}
            (EMPLOYEE CODE: {personal_information.employee_unique_id})
          </span>
        </div>
        <div className="field-row">
          <span className="field-label">2. Father's/Husband's Name</span>
          <span className="field-value">
            {personal_information.father_name} (M)
          </span>
        </div>
        <div className="field-row">
          <span className="field-label">3. Date of Birth</span>
          <span className="field-value">
            {personal_information.date_of_birth}
          </span>
        </div>
        <div className="field-row">
          <span className="field-label">4. Gender</span>
          <span className="field-value">{personal_information.gender}</span>
        </div>
        <div className="field-row">
          <span className="field-label">5. Marital Status</span>
          <span className="field-value">
            {personal_information.marital_status}
          </span>
        </div>
        <div className="address-section">
          <div className="field-label">6. Address</div>
          <div className="field-row">
            <span className="field-label address-label">Permanent</span>
            <span className="field-value address-value">
              {personal_information.permanent_address}
            </span>
          </div>
          <div className="field-row">
            <span className="field-label address-label">Temporary/Present</span>
            <span className="field-value address-value dotted">
              {personal_information.current_address}
            </span>
          </div>
        </div>
        <div className="nomination-text">
          I here by nominate the person(s)/cancel the nomination made by me
          previously and nominated the person below to receive any amount due to
          me from the employer, in the event to my death.
        </div>
        <table>
          <thead>
            <tr>
              <th>Name of the Nominee(s)</th>
              <th>Address</th>
              <th>Nominee's relationship with the member</th>
              <th>Date of Birth</th>
              <th>
                Total amount of share of accumulation in credit to be each
                nominee
              </th>
              <th>
                If the nominee mention name, relationship, address of guardian
                who may receive the amount during the minority nominee
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td />
              <td></td>
              <td />
            </tr>
          </tbody>
        </table>
        <div className="certification">
          <ol>
            <li>
              Certified that I have no family and should I acquire a family
              hereafter, the above nomination shall be deemed as cancelled.
            </li>
            <li>Certified that my father/mother is/are dependent on me.</li>
            <li>Strike out whichever is not applicable.</li>
          </ol>
        </div>
        <div className="signature-section">
          <div style={{ marginTop: 50 }}>
            Signature or thumb impression of the employed person
          </div>
        </div>
        <div className="certificate-title">CERTIFICATE BY EMPLOYER</div>
        <div className="certificate-text">
          Certified that the above declaration and nomination has been
          signed/thumb impressed before me by Mr.
          <span className="dotted-underline">{user.user_name}</span> in my
          establishment after he has read the entry/entries have been read over
          to him and got confired by him.
        </div>
        <div className="signature-line">
          <div>
            <div>Place:</div>
            <div style={{ marginTop: 20 }}>
              Date:
              <span
                style={{
                  borderBottom: '1px solid #000',
                  display: 'inline-block',
                  width: 150
                }}
              />
            </div>
          </div>
          <div className="signature-box">
            <div>
              Signature of the employer or other authorized officer of the
              establishment
            </div>
            <div style={{ marginTop: 20 }}>
              Designation:
              <span
                style={{
                  borderBottom: '1px solid #000',
                  display: 'inline-block',
                  width: 200
                }}
              />
            </div>
          </div>
        </div>
        <div className="company-info">
          KALYANI VENTURES LIMITED
          <br />
          <span className="dotted-underline">
            MEHERPADA, BULUPATNAIK CHOWK, BADMAL, P.O.- BADMAL, DIST.-
            JHARSUGUDA, ODISHA-768202
          </span>
          <br />
          Name and address of the Factory/Establishment and rubber stamp proof
        </div>
      </div>
    </React.Fragment>
  );
};

export default HRNominationForm;
